/** Display helpers shared by pages. */

import { plural } from "../../shared/words";

/** "just now", "5 minutes ago", "3 hours ago", "2 days ago", then the date. */
export function timeAgo(ms: number | null | undefined, now = Date.now()): string {
    if (!ms) return "Never";
    const s = Math.round((now - ms) / 1000);
    if (s < 45) return "just now";
    const m = Math.round(s / 60);
    if (m < 60) return `${plural(m, "minute")} ago`;
    const h = Math.round(m / 60);
    if (h < 24) return `${plural(h, "hour")} ago`;
    const d = Math.round(h / 24);
    if (d < 7) return `${plural(d, "day")} ago`;
    return new Date(ms).toLocaleDateString();
}

/** "now", "in 5 minutes", "in 3 hours". */
export function timeUntil(ms: number | null | undefined, now = Date.now()): string {
    if (!ms) return "";
    const s = Math.round((ms - now) / 1000);
    if (s < 45) return "now";
    const m = Math.round(s / 60);
    if (m < 60) return `in ${plural(m, "minute")}`;
    const h = Math.round(m / 60);
    if (h < 48) return `in ${plural(h, "hour")}`;
    return `in ${plural(Math.round(h / 24), "day")}`;
}

/** A repeat interval: "every minute", "every 15 minutes", "every hour", "every 6 hours". */
export function every(ms: number): string {
    const m = Math.max(1, Math.round(ms / 60_000));
    if (m < 60 || m % 60 !== 0) return m === 1 ? "every minute" : `every ${plural(m, "minute")}`;
    const h = m / 60;
    return h === 1 ? "every hour" : `every ${plural(h, "hour")}`;
}

/** A full date and time, for hover titles. */
export const dateTime = (ms: number | null | undefined) => (ms ? new Date(ms).toLocaleString() : "");

/** A ServiceM8 edit_date ("2019-03-04 10:00:00") as "March 2019". */
export function monthYear(editDate: string | null | undefined): string {
    if (!editDate) return "";
    const d = new Date(`${editDate.slice(0, 10)}T00:00:00`);
    return Number.isNaN(d.getTime()) ? editDate : d.toLocaleDateString(undefined, { month: "long", year: "numeric" });
}

export const count = (n: number) => n.toLocaleString();
